import React from 'react';
import SpeakerProfiles from "../components/speakers";

const Speakers = () => (
    <SpeakerProfiles />
);

export default Speakers;